module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAmElEQVR4Ae3NgQbDQBBF0fs3RWAhELB/EygggCIA7KeWJUIE2FKrVoiRRxTmDMC4D/d/zjnnRh5YOkZEE4U3nZHPFJ4IXpTvZQJnArl+TVw2U+othJP88vuZEaRmoueob/KJSp9YDxMDq5EXJoYmv5l5YWIjAhDtvDqxE4ns2Hl94mJemFDywkTiBknKCxOJGyUl75xzzn0ASSV4BtzUs3kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/baseline_expand_more_black_24dp.png
// module id = 114
// module chunks = 0